import { render, staticRenderFns } from "./OfferStatePage.vue?vue&type=template&id=85b43e82"
import script from "./OfferStatePage.vue?vue&type=script&lang=js"
export * from "./OfferStatePage.vue?vue&type=script&lang=js"
import style0 from "./OfferStatePage.vue?vue&type=style&index=0&id=85b43e82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports